import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=b3e03a6c&scoped=true&"
import script from "./Color.vue?vue&type=script&lang=js&"
export * from "./Color.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/Color/ColorStyle.css?vue&type=style&index=0&id=b3e03a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e03a6c",
  null
  
)

export default component.exports